import { render } from "./ScoreBar.vue?vue&type=template&id=e55889ea"
import script from "./ScoreBar.vue?vue&type=script&lang=js"
export * from "./ScoreBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__